import { Tooltip } from "@/components/ui/Tooltip";
import { formatCount, formatTokens } from "@/lib/utils";
import { cn } from "@/lib/utils";

/**
 * A token count that is compact on the row and exact in the tooltip.
 *
 * Tokens are the one number on this console that is both constantly present and
 * rarely needed to the digit, so the display is always compact — but a bill
 * argument needs the exact figure, and it lives one hover away rather than in a
 * separate export.
 */
export function TokenStat({
  prompt,
  completion,
  reasoning,
  className,
  showBreakdown = true,
}: {
  prompt: number;
  completion: number;
  reasoning: number;
  className?: string;
  showBreakdown?: boolean;
}) {
  const total = prompt + completion + reasoning;

  const detail = (
    <div className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 font-mono text-[10px]">
      <span className="text-[var(--color-fg-faint)]">prompt</span>
      <span className="text-right">{formatCount(prompt)}</span>
      <span className="text-[var(--color-fg-faint)]">completion</span>
      <span className="text-right">{formatCount(completion)}</span>
      <span className="text-[var(--color-fg-faint)]">reasoning</span>
      <span className="text-right">{formatCount(reasoning)}</span>
      <span className="border-t border-[var(--color-border)] pt-0.5 text-[var(--color-fg-subtle)]">
        total
      </span>
      <span className="border-t border-[var(--color-border)] pt-0.5 text-right">
        {formatCount(total)}
      </span>
    </div>
  );

  if (!showBreakdown) {
    return <span className={cn("font-mono tabular-nums", className)}>{formatTokens(total)}</span>;
  }

  return (
    <Tooltip content={detail}>
      <span className={cn("cursor-default font-mono tabular-nums", className)}>
        {formatTokens(total)}
      </span>
    </Tooltip>
  );
}
